module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/rectangleConversionL_CM.94766c28.svg";